var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"VImage",attrs:{"src":_vm.imageSource},on:{"error":function($event){_vm.useFallback=true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }